import { ClientesSegunlaempresa, extraerBitacoraCliente, extraerInformacionCliente, insertarEditarCliente, insertarNuevoCliente, insertartBitacora, traerTodosLosClientes, updateClientStatusApi } from "./Api_Clientes_Providers";

export const obtenerListaClientes = () => {
    // Retorna una función asíncrona que realiza la acción de obtener la lista completa de clientes
    return async () => {
        try {
            // Llama a la función traerTodosLosClientes para recuperar todos los clientes desde la API
            const resultado = await traerTodosLosClientes();

            // Devuelve el primer conjunto de datos encontrado en la respuesta
            return resultado.data["0"];
        } catch (error) {
            console.log("Error al obtener la lista de clientes: ", error);
        }
    };
};

export const getSpecificLead = (idCliente) => {
    // Retorna una función asíncrona que realiza la acción de obtener la información específica de un cliente por su ID
    return async () => {
        try {
            // Llama a la función extraerInformacionCliente con el idCliente para obtener detalles específicos del cliente
            const resultado = await extraerInformacionCliente({ idCliente });

            // Devuelve el primer conjunto de datos específicos del cliente dentro de la respuesta
            return resultado.data["0"]["0"];
        } catch (error) {
            console.log("Error al obtener la información específica del cliente: ", error);
        }
    };
};

export const getBitacoraLeads = (idCliente) => {
    // Retorna una función asíncrona que obtiene la bitácora de un cliente específico por su ID
    return async () => {
        try {
            // Llama a la función extraerBitacoraCliente con el idCliente para recuperar la bitácora del cliente
            const resultado = await extraerBitacoraCliente({ idCliente });

            // Devuelve el primer conjunto de registros de la bitácora del cliente
            return resultado.data["0"];
        } catch (error) {
            console.log("Error al obtener la bitácora del cliente: ", error);
        }
    };
};

export const insertartBitacoraCliente = ({ bitacora_cliente, bitacora_nombreCliente, bitacora_detalle }) => {
    // Retorna una función asíncrona que inserta una nueva entrada en la bitácora del cliente
    return async (dispatch, getState) => {
        const { id_admin, name_admin } = getState().auth;

        try {
            // Inserta en la bitácora con los detalles y datos del administrador
            await insertartBitacora({ bitacora_cliente, bitacora_nombreCliente, id_admin, name_admin, bitacora_detalle });

            // Devuelve un mensaje de éxito indicando que la bitácora fue creada correctamente
            return "Bitácora creada correctamente";
        } catch (error) {
            console.log("Error al insertar una nueva entrada en la bitácora del cliente: ", error);
            throw new Error("Error al crear bitácora"); // Devuelve error para manejo externo
        }
    };
};

export const crearCliente = (dataClient) => {
    // Retorna una función asíncrona que crea un nuevo cliente con los datos proporcionados
    return async (dispatch, getState) => {
        const { id_admin, name_admin } = getState().auth;

        try {
            // Llama a la función para insertar un nuevo cliente, obteniendo el ID del cliente recién creado
            const idResult = await insertarNuevoCliente({ dataClient, id_admin, name_admin });
            const idCliente = idResult.data[0][0].insertedId;

            // Inserta en la bitácora un registro para el cliente recién creado
            await dispatch(
                insertartBitacoraCliente({
                    bitacora_cliente: idCliente,
                    bitacora_nombreCliente: dataClient.nombre_cliente,
                    bitacora_detalle: "Cliente creado desde el sistema : " + dataClient.notasImportantes,
                }),
            );

            // Devuelve un mensaje de éxito indicando que el cliente fue creado correctamente
            return "Cliente creado correctamente";
        } catch (error) {
            console.log("Error al crear un nuevo cliente: ", error);
            throw new Error("Error al crear cliente"); // Manejo de error externo
        }
    };
};

export const editarCliente = (dataClient) => {
    // Retorna una función asíncrona que edita un cliente existente con los datos proporcionados
    return async (dispatch, getState) => {
        const { id_admin, name_admin } = getState().auth;

        try {
            // Llama a la función para insertar o editar un cliente, utilizando el ID del cliente existente
            await insertarEditarCliente({ dataClient, id_admin, name_admin });

            // Inserta un registro en la bitácora para reflejar la edición del cliente
            await dispatch(
                insertartBitacoraCliente({
                    bitacora_cliente: dataClient.id_cliente,
                    bitacora_nombreCliente: dataClient.nombre_cliente,
                    bitacora_detalle: "Cliente editado desde el sistema",
                }),
            );

            // Devuelve un mensaje de éxito indicando que el cliente fue editado correctamente
            return "Cliente editado correctamente";
        } catch (error) {
            console.log("Error al editar el cliente: ", error);
            throw new Error("Error al editar cliente"); // Manejo de error externo
        }
    };
};

export const cambiarelestadodelcleinte = (dataClient, valor) => {
    // Retorna una función asíncrona que cambia el estado del cliente al valor especificado
    return async (dispatch, getState) => {
        const { id_admin, name_admin } = getState().auth;

        try {
            // Llama a la función para actualizar el estado del cliente en la base de datos
            await updateClientStatusApi({ dataClient, id_admin, name_admin, valor });

            // Inserta un registro en la bitácora para reflejar el cambio de estado del cliente
            await dispatch(
                insertartBitacoraCliente({
                    bitacora_cliente: dataClient.id_cliente,
                    bitacora_nombreCliente: dataClient.nombre_cliente,
                    bitacora_detalle: `Se cambió el estado del cliente a: ${valor === 1 ? "Activo" : "Inactivo"}`,
                }),
            );

            // Devuelve un mensaje de éxito indicando que el estado del cliente fue actualizado correctamente
            return "Estado del cliente actualizado correctamente";
        } catch (error) {
            console.log("Error al cambiar el estado del cliente: ", error);
            throw new Error("Error al cambiar el estado del cliente"); // Manejo de error externo
        }
    };
};



export const traerTodoslosClientesSegunlaempresa = (empresaId) => {
    // Retorna una función asíncrona que cambia el estado del cliente al valor especificado
    return async () => {
        

        try {
            // Llama a la función para actualizar el estado del cliente en la base de datos
           const respons = await ClientesSegunlaempresa({ empresaId });


            return respons.data.data;
        } catch (error) {
            console.log("Error al cambiar el estado del cliente: ", error);
            throw new Error("Error al cambiar el estado del cliente"); // Manejo de error externo
        }
    };
};




/* comentarios corregidos*/